import e from "react";
import * as a from "@radix-ui/react-label";
const m = e.forwardRef(({ className: o, ...t }, r) => /* @__PURE__ */ e.createElement(a.Root, { ref: r, className: o, ...t }));
m.displayName = a.Root.displayName;
export {
  m as default
};
